import { render } from "./TabUtente.vue?vue&type=template&id=41f9ac68&scoped=true"
import script from "./TabUtente.vue?vue&type=script&lang=js"
export * from "./TabUtente.vue?vue&type=script&lang=js"

import "./TabUtente.vue?vue&type=style&index=0&id=41f9ac68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f9ac68"]])

export default __exports__